import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintDashboard } from '.';

/**
 * @component {kat-blueprint-dashboard-identify} KatBlueprintDashboardIdentify Component used to place and filter components within the identify section.
 * @slot default Blueprint content for identify section.
 */
@register(KatBlueprintDashboard.slotMapping.identify.name)
export class KatBlueprintDashboardIdentify extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintDashboard.slotMapping.identify.name,
      KatBlueprintDashboard.slotMapping.identify.allowed
    );
  }
}
